import React from 'react';

export default function SearchInput({
  value,
  onChange,
  placeholder = 'Search…',
  className = '',
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
}) {
  return (
    <div className={`relative ${className}`}>
      <i
        className="ti ti-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        style={{ fontSize: 14 }}
        aria-hidden="true"
      />
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-9 pr-3 py-2 text-[12.5px] font-medium text-gray-800 placeholder-gray-400 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy/20 focus:bg-white transition-all"
      />
    </div>
  );
}
